export const getIsErpJobDispatchEnabled = (state) => {
  return state?.companySettings?.erpJobDispatchEnabledAt != null;
};
